import type { EnvironmentRef } from '@fleequid-secrets/shared';
import { type CSSProperties, type ReactNode, useState } from 'react';
import { useOverlay } from '@/lib/overlay';
import { Icon } from './Icon';

// A protected environment asks before a change: what is about to happen, where, and the choice not to be asked again
// for a few minutes while working there.
export function ConfirmDialog(props: {
    environment: EnvironmentRef;
    what: string;
    onConfirm: (quiet: boolean) => void;
    onCancel: () => void;
}): ReactNode {
    useOverlay();
    const [quiet, setQuiet] = useState(false);

    return (
        <div className="scrim" onMouseDown={(event) => event.target === event.currentTarget && props.onCancel()}>
            <form
                className="dialog float protected"
                style={{ '--c': props.environment.color } as CSSProperties}
                onSubmit={(event) => {
                    event.preventDefault();
                    props.onConfirm(quiet);
                }}
                onKeyDown={(event) => event.key === 'Escape' && props.onCancel()}
            >
                <div className="sheet-head">
                    <div>
                        <h2>
                            <i className="dot halo" style={{ '--c': props.environment.color } as CSSProperties} />
                            Change {props.environment.name}?
                        </h2>
                        <p>{props.environment.name} is protected: every change here asks first.</p>
                    </div>
                    <button type="button" className="closebtn" onClick={props.onCancel} title="Cancel (esc)">
                        <Icon name="x" size={17} />
                    </button>
                </div>
                <div className="dialog-body">
                    <p>
                        You are about to <b>{props.what}</b>.
                    </p>
                    <button type="button" className={`toggle ${quiet ? 'on' : ''}`} onClick={() => setQuiet(!quiet)}>
                        <span className="sw" />
                        Don't ask again for 10 minutes
                    </button>
                    <div className="dialog-actions">
                        <button type="button" className="act" onClick={props.onCancel}>
                            Cancel
                        </button>
                        <button className="act primary" autoFocus>
                            Yes, change {props.environment.name}
                        </button>
                    </div>
                </div>
            </form>
        </div>
    );
}
